<template>
    <li class="headerCartItem">
        <article class="headerCartItem__article">
            <small class="headerCartItem__ref">Ref {{ item.ref }}</small>
            <h4 class="headerCartItem__title">{{ item.title }}</h4>

            <figure class="headerCartItem__fig">
                <img class="headerCartItem__img" :src="item.img" :alt="item.title">
            </figure>

            <div class="headerCartItem__info | row">
                <small class="headerCartItem__quantity">
                    {{ quantityLabel }}
                    <span>x{{ item.quantity }}</span>
                </small>

                <strong
                    class="headerCartItem__price"
                >{{ (item.priceFormatted) }}</strong>
            </div>

            <button class="headerCartItem__delete" @click="$emit('item-remove', item)">
                <span class="visually-hidden"><!-- @lang('misc.delete') -->Delete</span>
            </button>

            <button class="headerCartItem__edit" @click="$emit('item-edit', item)">
                <span class="visually-hidden">@lang('misc.edit')</span>
                <svg class="icon icon--edit" width="26" height="25" fill="#5c2d91" viewBox="0 0 26 25" aria-hidden="true">
                    <path d="M50.3145078,36.8242188 C49.5607574,36.0770161 48.3989664,35.9295889 47.4824766,36.4648438 L47.4824766,33.25 C47.4824766,31.9555826 46.433144,30.90625 45.1387266,30.90625 L43.9668516,30.90625 L43.9668516,29.34375 C43.9668516,28.0493326 42.917519,27 41.6231016,27 L28.3418516,27 C27.0474342,27 25.9981016,28.0493326 25.9981016,29.34375 L25.9981016,36.375 C25.9981016,36.8064725 26.3478791,37.15625 26.7793516,37.15625 C27.210824,37.15625 27.5606016,36.8064725 27.5606016,36.375 L27.5606016,29.34375 C27.5606016,28.9122775 27.9103791,28.5625 28.3418516,28.5625 L41.6231016,28.5625 C42.054574,28.5625 42.4043516,28.9122775 42.4043516,29.34375 L42.4043516,30.90625 L31.8574766,30.90625 C30.5630592,30.90625 29.5137266,31.9555826 29.5137266,33.25 L29.5137266,40.28125 C29.5137266,40.7127225 29.8635041,41.0625 30.2949766,41.0625 C30.726449,41.0625 31.0762266,40.7127225 31.0762266,40.28125 L31.0762266,33.25 C31.0762266,32.8185275 31.4260041,32.46875 31.8574766,32.46875 L45.1387266,32.46875 C45.570199,32.46875 45.9199766,32.8185275 45.9199766,33.25 L45.9199766,37.9023438 L39.8184141,44.0078125 C39.7308334,44.0923387 39.6651409,44.1969105 39.6270078,44.3125 L38.5215391,47.625 C38.4399248,47.8664176 38.4811872,48.132468 38.6320925,48.3378237 C38.7829978,48.5431793 39.0245772,48.662027 39.2793516,48.65625 C39.363195,48.6556398 39.446356,48.6411197 39.5254453,48.6132813 L42.8418516,47.5078125 C42.957052,47.4708054 43.0615883,47.4064753 43.1465391,47.3203125 L45.9199766,44.53125 L45.9199766,49.65625 C45.9199766,50.0877225 45.570199,50.4375 45.1387266,50.4375 L31.8574766,50.4375 C31.4260041,50.4375 31.0762266,50.0877225 31.0762266,49.65625 L31.0762266,43.40625 C31.0762266,42.9747775 30.726449,42.625 30.2949766,42.625 C29.8635041,42.625 29.5137266,42.9747775 29.5137266,43.40625 L29.5137266,46.53125 L28.3418516,46.53125 C27.9103791,46.53125 27.5606016,46.1814725 27.5606016,45.75 L27.5606016,39.5 C27.5606016,39.0685275 27.210824,38.71875 26.7793516,38.71875 C26.3478791,38.71875 25.9981016,39.0685275 25.9981016,39.5 L25.9981016,45.75 C25.9981016,47.0444174 27.0474342,48.09375 28.3418516,48.09375 L29.5137266,48.09375 L29.5137266,49.65625 C29.5137266,50.9506674 30.5630592,52 31.8574766,52 L45.1387266,52 C46.433144,52 47.4824766,50.9506674 47.4824766,49.65625 L47.4824766,42.96875 L50.3145078,40.140625 C50.7546103,39.7010119 51.0018984,39.1044748 51.0018984,38.4824219 C51.0018984,37.8603689 50.7546103,37.2638319 50.3145078,36.8242188 Z M49.2090391,39.0351563 L42.1582578,46.0859375 L40.4981016,46.6367188 L41.0527891,44.96875 L47.2324766,38.8007813 L47.2715391,38.7617188 L48.1035703,37.9375 C48.3010433,37.740027 48.5888664,37.6629051 48.8586195,37.7351852 C49.1283726,37.8074653 49.3390738,38.0181665 49.4113539,38.2879196 C49.483634,38.5576726 49.406512,38.8454958 49.2090391,39.0429688 L49.2090391,39.0351563 Z" transform="translate(-25.57 -27)"/>
                </svg>
            </button>
        </article>
    </li>
</template>

<script>

export default {


    /* Settings
    --------------------------------------------------------- */

    name: 'CartHeaderDropdownItem',

    components: {
    },

    props: {
        item: { type: Object, required: true },
        quantityLabel: { type: String, required: true },
    },

    data() {
        return {
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {

    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {
        // onFormLoadedEvent() {
        //     this.$el.querySelector('form').addEventListener('submit', (e) => {
        //         e.preventDefault()
        //         this.sendForm(e.currentTarget)
        //     })
        // },

        // sendForm(form) {
        //     const url = form.getAttribute('action')

        //     const h = new Headers()
        //     h.append('X-Requested-With', 'XMLHttpRequest')
        //     h.append('Accept', 'application/json')

        //     const formData = new FormData(form)

        //     const fetchOptions = {
        //         headers     : h,
        //         method      : 'POST',
        //         credentials : 'same-origin',
        //         body        : formData,
        //     }

        //     fetch(url, fetchOptions)
        //         .then(r => r.json())
        //         .then((json) => {
        //             // @todo : handle errors
        //             console.log(json)
        //             this.$refs.sideform.close()
        //         })
        // },
    },


    /* Handlers
    --------------------------------------------------------- */


}

</script>
